import { render } from "./clubSubscriptionBox.vue?vue&type=template&id=6fe52f1e&ts=true"
import script from "./clubSubscriptionBox.vue?vue&type=script&lang=ts"
export * from "./clubSubscriptionBox.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\projects\\Auraclub\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__